import { render, staticRenderFns } from "./registerV2.vue?vue&type=template&id=08e6ac6e&scoped=true&"
import script from "./registerV2.vue?vue&type=script&lang=js&"
export * from "./registerV2.vue?vue&type=script&lang=js&"
import style0 from "./registerV2.vue?vue&type=style&index=0&id=08e6ac6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e6ac6e",
  null
  
)

export default component.exports